import React, { FC } from 'react';
import '@barges/scss/lib/avatar.css';
import '@barges/scss/lib/popover.css';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';
import withPGTranslation from '../../config/withPGTranslation';
import AdvisorBonusCommon from './advisor_bonus_main';
import AdvisorBonusWrapper from './advisor_bonus_wrapper';

interface AdvisorBonusProps {
  isOpen: boolean;
  onCancel: () => void;
  user: User.Details;
  advisorId: string;
  clickSource?: string;
}

const AdvisorBonus: FC<AdvisorBonusProps> = ({
  isOpen, onCancel, clickSource, ...props
}) => {
  const skipBtnHandler = () => {
    onCancel();
  };
  const advisorBonusProps = {
    skipBtnHandler, isOpen, clickSource, ...props
  };

  const renderAdvisorBonus = () => (
    <Popover
      isOpen={ isOpen }
      renderTitle={ () => <></> }
      key="advisor-bonus-popover"
      centered
      style={ {
        padding: 5,
        rowGap: 0,
        maxWidth: '400px'
      } }
    >
      <AdvisorBonusCommon { ...advisorBonusProps } classNames={ classes.advisorBonusPopupContainer } />
    </Popover>
  );

  return <AdvisorBonusWrapper isOpen={ isOpen } user={ props.user } advisorId={ props.advisorId } onCancel={ onCancel } clickSource={ clickSource }>{ renderAdvisorBonus() }</AdvisorBonusWrapper>;
};

export default withPGTranslation(AdvisorBonus);
